import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge, Input, Button } from 'reactstrap'
import { saveCompanyMapping } from '../../actions/keeperReconActions'

const UnmappedCompaniesModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch()
  const unmappedCompanies = useSelector((state) => state.keeperRecon.unmappedCompanies)
  const companyLabels = useSelector((state) => state.keeperRecon.companyLabels)
  const [mappingState, setMappingState] = useState({}) // { [enterpriseId]: { companyId, searchText } }

  const getState = (id) => mappingState[id] || { companyId: '', searchText: '' }

  const updateState = (id, updates) => {
    setMappingState((prev) => ({ ...prev, [id]: { ...getState(id), ...updates } }))
  }

  const handleMap = (mc) => {
    const state = getState(mc.enterpriseId)
    if (!state.companyId) return

    const selected = companyLabels.find((c) => c.value === state.companyId)
    const companyType = selected?.label?.includes('(Essentials)') ? 'Essentials' : 'Managed'

    dispatch(saveCompanyMapping(mc.enterpriseId, mc.enterpriseName, state.companyId, companyType))
    setMappingState((prev) => {
      const next = { ...prev }
      delete next[mc.enterpriseId]
      return next
    })
  }

  const getFilteredLabels = (searchText) => {
    if (!searchText) return []
    return (companyLabels || []).filter((c) =>
      c.label?.toLowerCase().includes(searchText.toLowerCase())
    ).slice(0, 10)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Unmapped Keeper Companies
      </ModalHeader>
      <ModalBody>
        {(!unmappedCompanies || unmappedCompanies.length === 0) ? (
          <p className="text-muted">All synced Keeper companies are mapped.</p>
        ) : (
          <p className="text-muted small mb-3">
            These Keeper companies were found during sync but don't match any ConnectWise company.
            Map each one to a CW company to include it in reconciliation.
          </p>
        )}

        {(unmappedCompanies || []).map((mc) => {
          const state = getState(mc.enterpriseId)
          const filtered = getFilteredLabels(state.searchText)

          return (
            <div key={mc.enterpriseId} className="border rounded p-3 mb-2">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <strong>{mc.enterpriseName}</strong>
                  <Badge color="secondary" className="ms-2">{mc.numberOfUsers} users</Badge>
                </div>
              </div>
              <div className="d-flex gap-2">
                <div style={{ flex: 1, position: 'relative' }}>
                  <Input
                    type="text"
                    placeholder="Search ConnectWise companies..."
                    value={state.searchText}
                    onChange={(e) => updateState(mc.enterpriseId, { searchText: e.target.value, companyId: '' })}
                    bsSize="sm"
                  />
                  {state.searchText && !state.companyId && filtered.length > 0 && (
                    <div
                      className="border rounded bg-white shadow-sm"
                      style={{ position: 'absolute', zIndex: 10, width: '100%', maxHeight: '150px', overflowY: 'auto' }}
                    >
                      {filtered.map((c) => (
                        <div
                          key={c.value}
                          className="p-2 border-bottom"
                          style={{ cursor: 'pointer' }}
                          onClick={() => updateState(mc.enterpriseId, { companyId: c.value, searchText: c.label })}
                        >
                          <small>{c.label}</small>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <Button
                  size="sm"
                  color="primary"
                  disabled={!state.companyId}
                  onClick={() => handleMap(mc)}
                >
                  Map
                </Button>
              </div>
            </div>
          )
        })}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Close</Button>
      </ModalFooter>
    </Modal>
  )
}

export default UnmappedCompaniesModal
